import React from "react";

const services = [
  {
    img: "//swaarnima2ghee.com/cdn/shop/files/icons8-heart-health-96.png?v=1613666351",
    title: "Good For Heart",
    content:
      "A2 Desi Ghee contains Vitamin K2, which maintains an unrestricted flow of blood and a healthy balance of cholesterol for a healthy heart.",
  },
  {
    img: "//swaarnima2ghee.com/cdn/shop/files/salad.png?v=1613657825",
    title: "Rich of Nutrients",
    content:
      "Swaarnim's Vedic ghee is enriched with calcium, vitamins, proteins, and OMEGA 3 & OMEGA 6 fatty-acids, nourishing all the tissues.",
  },
  {
    img: "//swaarnima2ghee.com/cdn/shop/files/stomach.png?v=1613722773",
    title: "For Healthy Gut",
    content:
      "A2 Ghee is rich in naturally-occurring short-chain fatty acids and CLA that improve gut health, regulate metabolism, and help you maintain weight.",
  },
  {
    img: "//swaarnima2ghee.com/cdn/shop/files/cholesterol.png?v=1613723256",
    title: "Lower Cholesterol",
    content:
      "According to the Ayurveda, ghee is rich in fatty acids that support a healthy cardiovascular system and reduce unhealthy cholesterol levels.",
  },
];

const ServiceSection = () => {
  const servicestyle = `
.service-card {
  text-align: center;
  padding: var(--padding-card);
  border-radius: var(--border-radius-card);
  background-color: var(--bg-light);
  // box-shadow: var(--box-shadow-card);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  height: 100%;
}

.service-card:hover {
  transform: translateY(-5px);
  // box-shadow: var(--box-shadow-hover);
}

.service-icon img {
  width: 60px;
  height: 60px;
  object-fit: contain;
  margin-bottom: var(--space-sm);
}

.service-title {
  font-size: var(--font-base);
  font-weight: 700;
  font-family: var(--font-primary);
  text-transform: uppercase;
  margin-bottom: var(--space-xs);
  color: var(--color-primary);
}

.service-text {
  font-size: var(--font-sm);
  font-family: var(--font-secondary);
  color: var(--color-muted);
  line-height: 1.6;
}
  `;

  return (
    <>
      <style>{servicestyle}</style>
      <div className="container py-5">
        <div className="row g-4">
          {services.map((service, index) => (
            <div className="col-12 col-sm-6 col-lg-3" key={index}>
              <div className="service-card h-100">
                <div className="service-icon">
                  <img src={service.img} alt={service.title} />
                </div>
                <h4 className="service-title">{service.title}</h4>
                <p className="service-text">{service.content}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default ServiceSection;
